import React from 'react';
import { Card, CardContent, Grid, Typography } from '@mui/material';

type Props = { cards?: any };

class PlanningCycleCards extends React.PureComponent<Props> {
  metric(label: string, value: any, tone?: string) {
    return (
      <Grid size={{ xs: 6, md: 2 }} key={label}>
        <Card elevation={1}>
          <CardContent>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
            <Typography variant="h6" sx={{ fontWeight: 800, color: tone ? `${tone}.main` : 'text.primary' }}>
              {value ?? 0}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  render() {
    const c = this.props.cards || {};
    return (
      <Grid container spacing={2}>
        {this.metric('Total', c.total)}
        {this.metric('Draft', c.draft, 'warning')}
        {this.metric('Active', c.active, 'success')}
        {this.metric('BIE Phase', c.bie, 'info')}
        {this.metric('Planning', c.planning, 'success')}
        {this.metric('Governance', c.governance, 'secondary')}
      </Grid>
    );
  }
}

export default PlanningCycleCards;
